export interface IComplaintsBody {
  email: string;
  complaintId: number;
}

export enum EComplaintsFormStatus {
  default,
  loading,
  success,
  error,
}

export interface IComplaintsHelpers {
  sendComplaintFeedback(body: IComplaintsBody): void;
  statusChanger(status: EComplaintsFormStatus): void;
  complaintsFormStatus: EComplaintsFormStatus;
}
